<template>
<v-container>
  <v-data-table
    :loading="loading_data_table"
    :headers="headers"
    :items="desserts"
    sort-by="corporate_name"
    class="elevation-1"
    :footer-props="{
        itemsPerPageText:'Itens por pagina',
        itemsPerPageAllText:'Todos',
      }"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Organizaçoes</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" rounded dark class="mb-2" v-bind="attrs" v-on="on"
              ><v-icon small>mdi-plus</v-icon>nova organização</v-btn
            >
          </template>
          <v-card>
           <div class="title_body">
                  <span class="text_title text-h6">{{ formTitle }}</span>
                  <span class="btn_close"><v-btn icon dark @click="dialog = false" ><v-icon dark > mdi-close </v-icon></v-btn> </span>
             </div>

            <v-card-text>
              <v-container>
                <v-form class="px-3" @submit.prevent="submit()">
                  <v-row>
                    <v-col
                      ><v-text-field
                        dense
                        v-model="editedItem.corporate_name"
                        label="Razão Social"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        dense
                        v-model="editedItem.fantasy_name"
                        label="Nome Fantasia"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      ><v-text-field
                        dense
                        v-model="editedItem.cnpj"
                        label="CNPJ"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      ><v-text-field
                        dense
                        v-model="editedItem.telephone"
                        label="Telefone"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      ><v-text-field
                        dense
                        v-model="editedItem.email"
                        label="email"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="mx-0 mt-3 mr-1" @click="dialog = false"
                >Fechar</v-btn
              >
              <v-btn class="primary mx-0 mt-3" :loading="btnLoadingSave" :disabled="btnLoadingSave" @click="save">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="550px">
          <v-card>
            <v-card-title class="text-h5"
              >Tem certeza de que deseja excluir este item ?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="" @click="closeDelete">Cancelar</v-btn>
              <v-btn class="primary" @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      <v-icon class="mr-2" @click="deleteItem(item)"> mdi-delete </v-icon>
      <v-icon class="mr-2" @click="userOrganization(item)"
        >mdi-account-multiple</v-icon
      >
    </template>
    <template v-slot:no-data> Nenhum registro encontrado </template>
  </v-data-table>
  </v-container>
</template>


<script>
import { mapMutations } from 'vuex'
import service from "./service";
export default {
  data: () => ({
    btnLoadingSave:false,
    loading_data_table:false,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Nome Fantasia",
        align: "start",
        sortable: false,
        value: "fantasy_name",
      },
      { text: "Razão Social", value: "corporate_name" },
      { text: "CNPJ", value: "cnpj" },
      { text: "Telefone", value: "telephone" },
      { text: "Email", value: "email" },
      { text: "", align:"end",value: "actions", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      corporate_name: "",
      fantasy_name: "",
      cnpj: "",
      telephone: "",
      email: "",
      photo: "",
    },
    defaultItem: {
      id: "",
      corporate_name: "",
      fantasy_name: "",
      cnpj: "",
      telephone: "",
      email: "",
      photo: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Cadastrar Organização"
        : "Editar Organização";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapMutations('RegisterOrganizationUsers',['setOrganization']),
   
   initialize() {
     this.loading_data_table = true
      service.getAll().then((response) => {
        this.desserts = response.data;
        this.loading_data_table = false
      });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      let editedIndex = this.editedIndex;
      service.destroy(this.editedItem).then(() => {
        this.desserts.splice(editedIndex, 1);
        this.$toast.success("Excluído com sucesso.");
      });

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.btnLoadingSave = true
      if (this.editedIndex > -1) {
        //update
        let indice = this.editedIndex;
        service.update(this.editedItem).then((response) => {
          this.btnLoadingSave = false
          Object.assign(this.desserts[indice], response.data)
          this.close();
          this.$toast.success("Salvo com sucesso.")
        }).catch(()=>{
          this.btnLoadingSave = false
        })
      } else {
        //store
        service.store(this.editedItem).then((response) => {
          this.btnLoadingSave = false
          this.desserts.push(response.data)
          this.close()
          this.$toast.success("Salvo com sucesso.");
        }).catch(()=>{
          this.btnLoadingSave = false
        })
      }
      
    },
    userOrganization(item) {
      this.setOrganization(item);
      this.$router.push("/system/register_users_organization");
    },
  },
};
</script>
